import axios from "axios";
import React, {Component} from "react";
import Modal from "react-bootstrap/Modal";
import FeatherIcon from "feather-icons-react";
import { toast } from "react-toastify";
class CommuneForm extends Component{
    state = {
        id : null,
        name : "",
        territoryId : "",
        error : "",
        territories : [],
        communes : [],
    }

    handleInput = (e) => this.setState({ [e.target.name]: e.target.value });

    async territories(){
        const request = await axios('territories');
        if(request.status === 200) this.setState({ territories : request.data });
    }

    async communes(){
        const request = await axios('communes');
        if(request.status === 200) this.setState({ communes : request.data });
    }

    storeTerritory = () =>{
        const data = { territoryId : this.state.territoryId, name : this.state.name };
        const request = this.state.id
            ? axios.put('communes/'+this.state.id, data)
            : axios.post('communes', data);

        request.then((response) =>{
            this.props.showModal(response.data.data);
            toast(response?.data?.msg, { theme : "light", style : { backgroundColor : "blue", color : "white"}});
        }).catch((error) => {
            this.setState({ error : error.response?.data?.msg || "Une erreur est survenue." });
            toast(error.response?.data?.msg, { theme : "light", style : { backgroundColor : "red", color : "white"}});
        });
    }

    edit = () => {
        this.form();
        this.communes();
        this.territories();
    }

    form = () => {
        this.setState({
            id: this.props.formData ? this.props.formData.id : null,
            territoryId: this.props.formData ? this.props.formData.territoryId : "",
            name: this.props.formData ? this.props.formData.name : "",
            error : "",
        });
    }

    render(){
        return(
            <Modal
                show={this.props.isModal}
                onHide={this.props.showModal}
                size="lg"
                dialogClassName="student-form-dialog commune-form-dialog"
                contentClassName="student-form-modal student-form-modal--compact"
                onEntered={this.edit}
                backdrop="static"
            >
                <Modal.Header>
                    <div className="student-form__heading">
                        <span className="student-form__heading-icon"><FeatherIcon icon="navigation" size="20" /></span>
                        <div>
                            <span className="student-form__eyebrow">Référentiel géographique</span>
                            <Modal.Title>{this.state.id ? "Modifier la commune" : "Nouvelle commune"}</Modal.Title>
                        </div>
                    </div>
                </Modal.Header>

                <Modal.Body className="student-form__body commune-form__body">
                    {this.state.error && (
                        <div className="student-form__alert" role="alert">
                            <FeatherIcon icon="alert-circle" size="17" />
                            <span>{this.state.error}</span>
                        </div>
                    )}

                    <div className="commune-form__grid">
                        <section className="commune-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="map" size="15" /></span>
                                <div>
                                    <strong>Communes enregistrées</strong>
                                    <small>Sélectionnez une commune pour la modifier.</small>
                                </div>
                            </div>
                            <div className="commune-form__list">
                                {this.state.communes.length > 0 ? this.state.communes.map((commune) => (
                                    <button
                                        type="button"
                                        key={commune.id}
                                        className={`commune-form__item${this.state.id === commune.id ? " is-active" : ""}`}
                                        onClick={() => this.setState({
                                            id : commune.id,
                                            territoryId : commune.territoryId,
                                            name : commune.name,
                                            error : ""
                                        })}
                                    >
                                        <span><FeatherIcon icon="navigation" size="15" /></span>
                                        <strong>{commune.name}</strong> {commune.territory?.name}
                                        <FeatherIcon icon="chevron-right" size="15" />
                                    </button>
                                )) : (
                                    <div className="commune-form__empty">
                                        <FeatherIcon icon="map" size="24" />
                                        <span>Aucune commune enregistrée</span>
                                    </div>
                                )}
                            </div>
                        </section>

                        <section className="commune-form__panel">
                            <div className="student-form__section-title">
                                <span><FeatherIcon icon="edit-3" size="15" /></span>
                                <div>
                                    <strong>Informations de la commune</strong>
                                    <small>Associez la commune à son territoire.</small>
                                </div>
                            </div>
                            <div className="commune-form__fields">
                                <div className="form-group has-icon-left">
                                    <label htmlFor="commune-territory">Région / Territoire</label>
                                    <div className="position-relative">
                                        <select
                                            id="commune-territory"
                                            name="territoryId"
                                            className="form-control"
                                            onChange={this.handleInput}
                                            value={this.state.territoryId || ""}
                                        >
                                            <option value="">Sélectionner un territoire...</option>
                                            {this.state.territories.map((territory) => (
                                                <option key={territory.id} value={territory.id}>{territory.name}</option>
                                            ))}
                                        </select>
                                        <div className="form-control-icon"><FeatherIcon icon="map-pin" /></div>
                                    </div>
                                </div>

                                <div className="form-group has-icon-left">
                                    <label htmlFor="commune-name">Nom de la commune</label>
                                    <div className="position-relative">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Ex. Commune de..."
                                            onChange={this.handleInput}
                                            name="name"
                                            value={this.state.name}
                                            id="commune-name"
                                            autoFocus
                                        />
                                        <div className="form-control-icon"><FeatherIcon icon="navigation" /></div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <span className="student-form__footer-note">
                        <FeatherIcon icon="info" size="14" />
                        La commune sera disponible dans les listes géographiques
                    </span>
                    <button type="button" onClick={this.props.showModal} className="btn btn-light student-form__button">
                        <FeatherIcon icon="x" size="16" /> Fermer
                    </button>
                    <button type="button" onClick={this.storeTerritory} className="btn btn-primary student-form__button">
                        <FeatherIcon icon="check" size="16" /> Sauvegarder
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default CommuneForm;
